import { render } from "./ThirdCardDesign.vue?vue&type=template&id=13de6d6a&scoped=true"
import script from "./ThirdCardDesign.vue?vue&type=script&lang=js"
export * from "./ThirdCardDesign.vue?vue&type=script&lang=js"

import "./thirdCardDesign.scss?vue&type=style&index=0&id=13de6d6a&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13de6d6a"]])

export default __exports__